export default __webpack_public_path__ + "static/media/Software-Downloading-img3.05814048.png";